"use client";

import React, { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function KompaniyaHaqida() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="223603" id="built-on-integrity" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-secondary/5 -skew-x-12 translate-x-1/4 pointer-events-none hidden lg:block" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className="relative rounded-md overflow-hidden shadow-xl transition-all duration-1000 ease-out opacity-100 translate-x-0 !bg-[url(https://modern-joey.10web.cloud/wp-content/uploads/2026/05/360_F_596749061_IHWpCzIukPyVs7M8Y9mVTHVWNyYmUeLs.jpg)] !h-[325px]">
            
            
            {}
            <div className="absolute bottom-0 left-0 w-full h-2 bg-secondary z-20" />
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="w-16 h-1.5 bg-secondary mb-8 rounded-md" />
            
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary mb-8">
              Built on Integrity
            </h2>
            
            <div className="space-y-6 text-muted-foreground text-lg md:text-xl leading-relaxed font-serif">
              <p><span className="text-5xl md:text-6xl float-left mr-3 mt-1 font-default text-secondary leading-none" data-ast-id="f:/src/pages/TheBTStory/sections/KompaniyaHaqida.tsx|sig:4rxusz" data-ast-start="3461" data-ast-end="3570">A</span>t BT Remodeling, we believe that high-end customer service is as much about the relationship as it is about the result. As a licensed and insured residential general contractor serving the Denver metro area, we bring architectural precision to every floor plan design and 3D model we create.</p>
              <p>Our team of master craftsmen specializes in whole-home transformations, from bespoke kitchen remodels to complex structural additions and ADUs. We don't just build spaces; we engineer environments that reflect your lifestyle with the uncompromising quality that only true craftsmen can provide.</p>
            </div>

            <div className="mt-12 pt-8 border-t border-border flex flex-col items-start">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/bt_remodeling_seal_of_quality.png" alt="BT Remodeling Certification" className="h-14 md:h-16 object-contain opacity-90 mb-4 filter grayscale brightness-50" />
              <div className="flex flex-col">
                <span className="font-default font-bold text-primary text-lg">The BT Remodeling Standard</span>
                <span className="text-secondary text-sm font-medium tracking-widest uppercase mt-1">Licensed & Insured Professionals</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}